module.exports = __webpack_public_path__ + "static/media/notification.01daeb3d.png";